module.exports = __webpack_public_path__ + "img/signin-bg.545348a.png";